import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const defaultDatos = {
  sucursal: {
    _id: null,
    descripcion: "",
    roles: []
  },
};

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || null,
    datos: localStorage.getItem("datos") ? JSON.parse(localStorage.getItem("datos")) : defaultDatos
  },
  mutations: {
    setLogin(state, payload) {
      state.token = payload.token;
      state.datos = payload.datos;
      localStorage.setItem("token", payload.token);
      localStorage.setItem("datos", JSON.stringify(payload.datos));
    },
    removeLogin(state) {
      state.token = null;
      state.datos = defaultDatos;
      localStorage.removeItem("token");
      localStorage.removeItem("datos");
    },
  },
  actions: {
    async iniciarSesion({ commit }, formulario) {
      try {
        const login = await axios.post("/login", formulario);
        commit("setLogin", login.data);
        return true;
      } catch (error) {
        throw error;
      }
    }
  },
  modules: {},
});
